module.exports = __webpack_public_path__ + "store-availability-out-of-stock/store-availability-out-of-stock-a4f8e75f65be3456dd1da662bdf241ee.svg";